import {
  Box,
  Flex,
  Spinner,
  Table,
  Tbody,
  Td,
  Text,
  Tr,
  useColorModeValue,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
} from "@chakra-ui/react";

import { PaginateNavigate } from "components/paginateComponent/PaginateComponent";

// Custom components
import * as React from "react";
import { useClients } from "hooks/ClientsHook";
import { useQuery } from "react-query";

interface DefaultProps {
  id: number;
}

// const columns = columnsDataCheck;
export function BackupTable({ id }: DefaultProps) {
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const [paginate, setPaginate] = React.useState<number>(1);

  const { findBKPListClientById } = useClients();
  const { data, isLoading } = useQuery(["findBKPListClientById", id], () =>
    findBKPListClientById(id)
  );

  return (
    <Flex
      direction="column"
      w="100%"
      overflowX={{ sm: "scroll", lg: "hidden" }}
    >
      {isLoading ? (
        <Box
          display="flex"
          alignItems="center"
          padding={30}
          justifyContent="center"
        >
          <Spinner width={100} height={100} />
        </Box>
      ) : (
        <>
          {}
          <Box>
            <Flex px="25px" mb="8px" justifyContent="center" align="center">
              <Text
                color={textColor}
                fontSize="21px"
                fontWeight="700"
                lineHeight="100%"
              >
                Backup
              </Text>
            </Flex>
            <Flex
              px="25px"
              mb="8px"
              justifyContent="space-between"
              align="center"
            >
              <Text
                color={textColor}
                fontSize="14px"
                fontWeight="700"
                lineHeight="100%"
              >
                TOTAL : {data?.total}
              </Text>
            </Flex>
            <Table variant="simple" color="gray.500" mt="12px">
              <Tbody>
                {data?.data.map((data: any) => (
                  <Tr key={data.ID} cursor="pointer" _hover={{ opacity: 0.6 }}>
                    <Td colSpan={1} borderColor="transparent">
                      <Accordion allowToggle>
                        <AccordionItem borderColor="transparent">
                          <AccordionButton>
                            <Box
                              color={
                                data.REALIZADO === "N" ? "red.500" : textColor
                              }
                              flex="1"
                              textAlign="left"
                            >
                              {data.DATA}
                            </Box>
                          </AccordionButton>
                          <AccordionPanel pb={1}>
                            <Box fontSize={{ sm: "14px" }}>
                              <Box
                                minW={{ sm: "150px", md: "200px", lg: "auto" }}
                              >
                                Realizado:
                                {data.REALIZADO === "N" ? "NÃO" : "SIM"}
                              </Box>
                              <Box
                                minW={{ sm: "150px", md: "200px", lg: "auto" }}
                              >
                                Observação: {data.OBSERVACAO}
                              </Box>
                              <Box
                                minW={{ sm: "150px", md: "200px", lg: "auto" }}
                              >
                                Via SSH: {data.VIA_SSH === true ? "SIM" : "NÃO"}
                              </Box>
                              <Box
                                minW={{ sm: "150px", md: "200px", lg: "auto" }}
                              >
                                Versão: {data.VERSAO}
                              </Box>
                            </Box>
                          </AccordionPanel>
                        </AccordionItem>
                      </Accordion>
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </Box>
          <PaginateNavigate
            key={paginate}
            current_page={data?.current_page}
            pages_preview={data?.links}
            pageSelect={setPaginate}
            lastPage={data?.last_page}
          />
        </>
      )}
    </Flex>
  );
}
